import { CollectionRef } from "@/types/collection"
import { EntityRef } from "@/types/entity"

import { webStorage } from "@/lib/web-storage"

export type PendingSaveAction =
  | {
      type: "place" | "guide"
      entityRef: EntityRef
      title: string // for toast message
    }
  | {
      type: "collection"
      collectionRef: CollectionRef
      title: string // for toast message
    }

const STORAGE_KEY = "mindtrip.pending_save" as const

export function setPendingSave(action: PendingSaveAction) {
  webStorage.setJSON(STORAGE_KEY, action, { type: "session" })
}

export function getPendingSave(): PendingSaveAction | null {
  return webStorage.tryGetJSON<PendingSaveAction>(STORAGE_KEY, {
    type: "session",
  })
}

export function clearPendingSave() {
  webStorage.removeItem(STORAGE_KEY, { type: "session" })
}
